import React from 'react';
import { Box, Container, Grid, Typography, Button, IconButton, Stack, Divider, Chip } from '@mui/material';
import { 
  Facebook, Twitter, Instagram, YouTube, WhatsApp, 
  Shop, Apple, Campaign, RocketLaunch, ChevronRight 
} from '@mui/icons-material';
import { Link } from 'react-router-dom';

export default function Footer() {
  const primaryGradient = 'linear-gradient(135deg, #FF512F 0%, #DD2476 100%)';
  const darkBg = '#070B14';
  const cardBg = 'rgba(255, 255, 255, 0.03)';

  const quickLinks = [
    { label: 'होम / Home', path: '/' },
    { label: 'मूल्य / Pricing', path: '/price' },
    { label: 'हमारे बारे में / About Us', path: '/about-us' },
    { label: 'सामान्य प्रश्न / FAQ', path: '/faq' },
  ];

  const legalLinks = [
    { label: 'नियम व शर्तें / Terms', path: '/terms' },
    { label: 'प्राइवेसी / Privacy Policy', path: '/privacy' },
    { label: 'रिफंड / Refund Policy', path: '/refund' },
    { label: 'खाता हटाएं / Delete', path: '/delete' },
  ];

  return (
    <Box sx={{ position: 'relative', pt: { xs: 10, md: 12 }, bgcolor: '#f4f6f8' }}> 
      
      <Box 
        component="footer" 
        sx={{ 
          bgcolor: darkBg, 
          color: 'white', 
          pt: { xs: 12, md: 8 }, 
          pb: { xs: 14, sm: 4 },
          position: 'relative', 
          borderTopLeftRadius: { xs: 30, md: 50 }, 
          borderTopRightRadius: { xs: 30, md: 50 } 
        }}
      >
        <Box sx={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: '50%', height: '2px', background: primaryGradient, boxShadow: '0 0 15px 3px rgba(255, 81, 47, 0.4)' }} />

        <Container maxWidth="lg">
          
          {/* 🌟 COMPACT FLOATING BANNER 🌟 */}
          <Box 
            sx={{ 
              background: 'linear-gradient(135deg, #FF6A00 0%, #EE0979 100%)', 
              borderRadius: 4, p: { xs: 3, md: 4 }, textAlign: 'center', 
              mt: { xs: -18, md: -15 }, mb: 6, 
              boxShadow: '0 15px 35px -10px rgba(238, 9, 121, 0.4)',
              position: 'relative', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.2)'
            }}
          >
            <Box sx={{ position: 'absolute', top: -50, left: -20, width: 150, height: 150, background: 'radial-gradient(circle, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 70%)', borderRadius: '50%' }} />
            <Box sx={{ position: 'absolute', bottom: -60, right: -20, width: 200, height: 200, background: 'radial-gradient(circle, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0) 70%)', borderRadius: '50%' }} />
            
            <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <RocketLaunch sx={{ fontSize: 36, color: 'white', mb: 1.5, filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.3))' }} />
              <Typography variant="h4" fontWeight="800" gutterBottom sx={{ fontSize: { xs: '1.6rem', sm: '2.1rem' }, letterSpacing: '-0.5px', textShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
                अपना प्रभाव बढ़ाएं, अभी डाउनलोड करें!
              </Typography>
              <Typography variant="subtitle1" sx={{ mb: 3, opacity: 0.9, fontWeight: 500, maxWidth: '500px', fontSize: { xs: '0.9rem', sm: '1rem' }, lineHeight: 1.4 }}>
                भारत के 10,000+ से ज़्यादा नेता PracharApp का इस्तेमाल कर रहे हैं।
              </Typography>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="center" width={{ xs: '100%', sm: 'auto' }}>
                <Button variant="contained" startIcon={<Shop />} sx={{ bgcolor: 'white', color: '#EE0979', fontWeight: '800', fontSize: '0.95rem', px: 3, py: 1, borderRadius: '50px', boxShadow: '0 8px 20px rgba(0,0,0,0.15)', '&:hover': { bgcolor: '#f8fafc', transform: 'translateY(-2px)' }, transition: 'all 0.3s' }}>
                  Google Play
                </Button>
                <Button variant="outlined" startIcon={<Apple />} sx={{ borderColor: 'rgba(255,255,255,0.6)', color: 'white', fontWeight: 'bold', fontSize: '0.95rem', px: 3, py: 1, borderRadius: '50px', backdropFilter: 'blur(5px)', '&:hover': { bgcolor: 'rgba(255,255,255,0.1)', borderColor: 'white', transform: 'translateY(-2px)' }, transition: 'all 0.3s' }}>
                  App Store
                </Button>
              </Stack>
            </Box>
          </Box>

          <Grid container spacing={5}>
            {/* 🌟 BRAND INFO 🌟 */}
            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2.5 }}>
                <Box sx={{ width: 40, height: 40, mr: 1.5, borderRadius: '10px', background: primaryGradient, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', boxShadow: '0 4px 15px rgba(221, 36, 118, 0.4)' }}>
                  <Campaign sx={{ fontSize: 24 }} />
                </Box>
                <Typography variant="h5" fontWeight="900" sx={{ letterSpacing: '-0.5px' }}>
                  <span style={{ color: '#ffffff' }}>Prachar</span>
                  <span style={{ background: primaryGradient, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>App</span>
                </Typography>
              </Box>
              <Typography variant="body2" sx={{ color: '#94A3B8', mb: 3, lineHeight: 1.7 }}>
                हम सिर्फ पोस्टर नहीं बनाते, हम आपकी पहचान बनाते हैं। गाँव के सरपंच से लेकर देश के सांसद तक की पहली पसंद।
              </Typography>
              <Stack direction="row" spacing={1.5}>
                {[<Facebook/>, <Twitter/>, <Instagram/>, <YouTube/>, <WhatsApp/>].map((icon, i) => (
                  <IconButton key={i} size="small" sx={{ color: 'white', bgcolor: cardBg, border: '1px solid rgba(255,255,255,0.1)', transition: 'all 0.3s', '&:hover': { background: primaryGradient, border: '1px solid transparent', transform: 'translateY(-3px)' } }}>
                    {icon}
                  </IconButton>
                ))}
              </Stack>
            </Grid>

            {/* 🌟 STYLISH QUICK LINKS 🌟 */}
            <Grid item xs={6} md={2}>
              <Typography variant="subtitle1" fontWeight="800" sx={{ mb: 1, color: 'white', letterSpacing: '0.5px' }}>
                क्विक लिंक्स
              </Typography>
              {/* Decorative Accent Line */}
              <Box sx={{ width: 35, height: 3, bgcolor: '#FF6A00', borderRadius: 2, mb: 2.5 }} />
              
              <Stack spacing={0.5}>
                {quickLinks.map((item, i) => (
                  <Box 
                    key={i} 
                    component={Link} 
                    to={item.path} 
                    sx={{ 
                      display: 'flex', alignItems: 'center', color: '#94A3B8', 
                      textDecoration: 'none', transition: 'all 0.3s',
                      p: 1, borderRadius: '6px', marginLeft: -1, // Negative margin to align perfectly with header
                      '&:hover': { 
                        color: '#ffffff', 
                        bgcolor: 'rgba(255, 106, 0, 0.1)', 
                        transform: 'translateX(6px)',
                        boxShadow: '-3px 0 0 0 #FF6A00' // Cool left border highlight
                      },
                      '&:hover .link-icon': { color: '#FF6A00', transform: 'translateX(3px)' }
                    }}
                  >
                    <ChevronRight className="link-icon" sx={{ fontSize: 18, mr: 0.5, transition: 'all 0.3s' }} />
                    <Typography variant="body2" fontWeight="600">{item.label}</Typography>
                  </Box>
                ))}
              </Stack>
            </Grid>

            {/* 🌟 STYLISH LEGAL LINKS 🌟 */}
            <Grid item xs={6} md={2}>
              <Typography variant="subtitle1" fontWeight="800" sx={{ mb: 1, color: 'white', letterSpacing: '0.5px' }}>
                कानूनी
              </Typography>
              <Box sx={{ width: 35, height: 3, bgcolor: '#FF6A00', borderRadius: 2, mb: 2.5 }} />
              
              <Stack spacing={0.5}>
                {legalLinks.map((item, i) => (
                  <Box 
                    key={i} 
                    component={Link} 
                    to={item.path} 
                    sx={{ 
                      display: 'flex', alignItems: 'center', color: '#94A3B8', 
                      textDecoration: 'none', transition: 'all 0.3s',
                      p: 1, borderRadius: '6px', marginLeft: -1,
                      '&:hover': { 
                        color: '#ffffff', 
                        bgcolor: 'rgba(255, 106, 0, 0.1)', 
                        transform: 'translateX(6px)',
                        boxShadow: '-3px 0 0 0 #FF6A00'
                      },
                      '&:hover .link-icon': { color: '#FF6A00', transform: 'translateX(3px)' }
                    }}
                  >
                    <ChevronRight className="link-icon" sx={{ fontSize: 18, mr: 0.5, transition: 'all 0.3s' }} />
                    <Typography variant="body2" fontWeight="600">{item.label}</Typography>
                  </Box>
                ))}
              </Stack>
            </Grid>

            {/* 🌟 CHIPS 🌟 */}
            <Grid item xs={12} md={4}>
              <Typography variant="subtitle1" fontWeight="800" sx={{ mb: 1, color: 'white', letterSpacing: '0.5px' }}>
                आपको क्या मिलता है?
              </Typography>
              <Box sx={{ width: 35, height: 3, bgcolor: '#FF6A00', borderRadius: 2, mb: 2.5 }} />
              
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
                {['✨ AI डिज़ाइन', '🚀 10K+ टेम्प्लेट', '🔥 HD क्वालिटी', '📱 1-क्लिक शेयर', '🇮🇳 हिंदी सपोर्ट', '🎬 वीडियो मेकर'].map((feat, i) => (
                  <Chip 
                    key={i} 
                    label={feat} 
                    size="medium"
                    sx={{ 
                      bgcolor: '#0f172a', color: '#E2E8F0', border: '1px solid rgba(255,255,255,0.08)',
                      fontWeight: 600, borderRadius: '8px', px: 0.5, transition: 'all 0.2s',
                      '&:hover': { bgcolor: 'rgba(255, 106, 0, 0.1)', borderColor: '#FF6A00', color: '#FF6A00' }
                    }} 
                  />
                ))}
              </Box>
            </Grid>
          </Grid>

          <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.08)' }} />

          {/* 🌟 BOTTOM BAR 🌟 */}
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: 'center', textAlign: 'center' }}>
            <Typography variant="body2" sx={{ color: '#64748B', fontWeight: 500 }}>
              &copy; {new Date().getFullYear()} <span style={{ color: 'white' }}>PracharApp</span>. All Rights Reserved.
            </Typography>
            <Typography variant="body2" sx={{ color: '#64748B', mt: { xs: 1.5, md: 0 }, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 0.5 }}>
              Made with <span style={{ color: '#EE0979', fontSize: '1.1rem' }}>❤️</span> in India
            </Typography>
          </Box>

        </Container>
      </Box>
    </Box>
  );
}